import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=da8430f4&"
import script from "./Achievements.vue?vue&type=script&lang=js&"
export * from "./Achievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Achievements.vue"
export default component.exports